export default {
  title: 'Vivez la meilleure expérience sur notre appli mobile',
  description: 'Gagnez du temps, accumulez des récompenses, recevez des offres et bien plus encore',
  buttons: {
    download: "Ouvrir l'appli {{name}}",
  },
};
